// extracted by mini-css-extract-plugin
export var hero = "header-module--hero--2tp-B";
export var jsAnimInit = "header-module--jsAnimInit--3uc6d";
export var description = "header-module--description--2FCH3";
export var title = "header-module--title--lqAlO";